const GTM_ID = process.env.REACT_APP_GTM_ID;

function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
}

export function initAnalytics() {
    gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        wait_for_update: 500,
    });
    let consent = null;
    try { consent = localStorage.getItem("b24_consent"); } catch {}
    if (consent === "all") grantAnalyticsConsent();
}

export function grantAnalyticsConsent() {
    gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
    });
    loadGtm();
}

function loadGtm() {
    if (!GTM_ID || window.__b24GtmLoaded) return;
    window.__b24GtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(s);
}

export function trackEvent(event, params = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}
